
import { useBusinessSettingsBase } from './useBusinessSettingsBase';
import { useBusinessBillingState } from './useBusinessBillingState';
import { formatCurrency } from '@/hooks/portfolioSettings/billingUtils';

export const useBusinessSettingsState = (initialTab = 'billing') => {
  const baseState = useBusinessSettingsBase(initialTab);
  const billingState = useBusinessBillingState(baseState.business);

  return {
    // From base state
    business: baseState.business,
    businessId: baseState.businessId,
    activeTab: baseState.activeTab,
    setActiveTab: baseState.setActiveTab,
    navigate: baseState.navigate,
    handleEditCampaign: baseState.handleEditCampaign,
    allBusinesses: baseState.allBusinesses,
    
    // From billing state
    formatCurrency,
    billingData: billingState.billingData,
    showSearch: billingState.showSearch,
    selectedPaymentMethod: billingState.selectedPaymentMethod,
    setSelectedPaymentMethod: billingState.setSelectedPaymentMethod,
    totalCharge: billingState.totalCharge,
    handleChangeBillingManager: billingState.handleChangeBillingManager,
    handleAddPaymentMethod: billingState.handleAddPaymentMethod,
    handleAddPromoCode: billingState.handleAddPromoCode,
    handleMakePrimary: billingState.handleMakePrimary
  };
};
